import React from 'react';
import PropTypes from 'prop-types';

function IconSampler({ size = 17, color, style, className, onClick }) {
  return (
    <svg className={className} onClick={onClick} style={style} width={size} height={size} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 17.3 17">
      <path fill={color} d="M15.7,0h-14C0.7,0,0,0.7,0,1.7c0,0,0,0,0,0v13.7C0,16.3,0.7,17,1.7,17l0,0h14c0.9,0,1.7-0.8,1.7-1.7V1.7C17.3,0.8,16.6,0,15.7,0z M15.7,15.3h-14V1.7h14V15.3z"/>
      <g>
      	<rect x="9.4" y="3.8" fill={color} width="4.1" height="4.1"/>
      	<rect x="9.4" y="9.1" fill={color} width="4.1" height="4.1"/>
      	<rect x="3.8" y="3.8" fill={color} width="4.1" height="4.1"/>
      	<rect x="3.8" y="9.1" fill={color} width="4.1" height="4.1"/>
      </g>
    </svg>
  )
}

IconSampler.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default IconSampler;
